exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-03f4433b] div.v-input--radio-group > div.v-input__control {\n    width: 100%;\n}\n\n\n", ""]);

// exports
